<template>
  <v-app >
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
//import ApolloExample from './components/ApolloExample';
//import Layout from './components/Layout';
//import CategoryViewer from './components/CategoryViewer'

export default {
  name: 'App',

  components: {
 //   Layout,
 //   CategoryViewer,
  },
  data () {
    return {
      loggedIn: false
    }
  },
  created () {
    this.$cognitoAuth.isAuthenticated((err, loggedIn) => {
      if (err) {
        console.error("App: Couldn't get the session:", err, err.stack)
        return
      }
      this.loggedIn = loggedIn
    })
    this.$cognitoAuth.onChange = loggedIn => {
      this.loggedIn = loggedIn
    }
  }
  
};
</script>
